import { useAppSelector } from "../../store/hooks";
import drawerStyles from "../../styles/drawer.module.css";
import labels from "../../utils/labels";
import ColorChip from "../UI/chips/ColorChip";
import InfoBoxGreyBlackColumns from "./InfoBoxGreyBlackColumns";
import InfoBoxRow from "./InfoBoxRow";

const GeneralTaskInfoBox = () => {
  const selectedTask = useAppSelector(
    (state) => state.drawerSlice.selectedTask,
  );

  const priorityConfig: Record<string, { label:
  string; color: string }> = {
    HIGH: { label: labels.high, color:
  "var(--col-error-3)" },
    LOW: { label: labels.low, color:
  "var(--col-graph-first-2)" },
  };
  const defaultPriority = { label: labels.normal,
  color: "var(--col-interaction-tertiary)" };

  const { label: priorityLabel, color:
  priorityColor } =
    priorityConfig[selectedTask?.task.priority ??
  ""] ?? defaultPriority;

  return (
    <div className={drawerStyles.generalTaskInfoBox}>
      {selectedTask && (
        <>
          <InfoBoxRow title={labels.priority}>
            <ColorChip text={priorityLabel} color={priorityColor} />
          </InfoBoxRow>
          <InfoBoxRow title={labels.citizenDetails}>
            <InfoBoxGreyBlackColumns
              key={labels.citizen}
              firstColumn={labels.citizen}
              secondColumn={selectedTask.task.client.description}
            />
            <InfoBoxGreyBlackColumns
              key={labels.address}
              firstColumn={labels.address}
              secondColumn={
                <span>{`${selectedTask.task.address}, ${selectedTask.task.postalCode} ${selectedTask.task.district}`}</span>
              }
            />
          </InfoBoxRow>
          <InfoBoxRow title={labels.skillRequirement}>
            <InfoBoxGreyBlackColumns
              key={labels.skills}
              firstColumn={labels.skills}
              secondColumn={selectedTask.task.requiredSkills}
            />
          </InfoBoxRow>
        </>
      )}
    </div>
  );
};

export default GeneralTaskInfoBox;
